import React from "react"

function TimelineContent(props) {
  return <div className="timeline-content">{props.children}</div>
}

export default TimelineContent
